import { CompanyData } from './types';
import { ReceitaWsCompanyData } from '../../services/clients/ClientService';
import { ClientResponse } from '../../types/dtos';

/**
 * Mapeia os dados da ReceitaWS para o formato padronizado CompanyData
 */
export function mapReceitaWsToCompanyData(data: ReceitaWsCompanyData): CompanyData {
  if (!data) return {};
  
  return {
    // Dados básicos
    cnpj: data.cnpj,
    razaoSocial: data.nome,
    nomeFantasia: data.fantasia,
    tipo: data.tipo,
    porte: data.porte,
    abertura: data.abertura,
    situacao: data.situacao,
    situacaoCadastral: data.situacao,
    naturezaJuridica: data.naturezaJuridica,
    capitalSocial: data.capitalSocial,
    
    // Endereço
    logradouro: data.logradouro,
    numero: data.numero,
    complemento: data.complemento,
    bairro: data.bairro,
    cep: data.cep,
    municipio: data.municipio,
    cidade: data.municipio,
    estado: data.uf,
    uf: data.uf,
    
    // Contato
    telefone: data.telefone,
    telefone1: data.telefone,
    email: data.email,
    
    // Atividades
    atividadePrincipal: data.atividadePrincipal,
    atividadesSecundarias: data.atividadesSecundarias,
    
    // Sócios
    qsa: data.qsa,
    
    // Dados fiscais
    simples: data.simples,
    simei: data.simei,
    
    // Outros
    efr: data.efr,
    ultimaAtualizacao: data.ultimaAtualizacao,
  };
}

/**
 * Mapeia os dados do Cliente para o formato padronizado CompanyData
 */
export function mapClientToCompanyData(client: ClientResponse): CompanyData {
  if (!client) return {};

  return {
    // Dados básicos
    id: client.id,
    cnpj: client.cnpj,
    razaoSocial: client.razaoSocial,
    nomeFantasia: client.nomeFantasia,
    tipo: client.tipoCliente,
    porte: client.porte,
    situacao: client.situacaoCadastral,
    situacaoCadastral: client.situacaoCadastral,
    naturezaJuridica: client.naturezaJuridica,
    capitalSocial: client.capitalSocial,

    // Endereço
    logradouro: client.logradouro,
    numero: client.numero,
    complemento: client.complemento,
    bairro: client.bairro,
    cep: client.cep,
    cidade: client.cidade,
    estado: client.estado,
    uf: client.estado,

    // Contato
    telefone: client.telefone1,
    telefone1: client.telefone1,
    email: client.email,

    // Atividades (usando a propriedade activities do ClientResponse)
    activities: client.activities,

    // Partners (usando a propriedade partners do ClientResponse)
    partners: client.partners,

    // Dados fiscais
    simples: {
      optante: client.optanteSimples || false,
      dataOpcao: client.dataOpcaoSimples?.toString(),
      dataExclusao: client.dataExclusaoSimples?.toString()
    },
    simei: {
      optante: client.optanteSimei || false,
      dataOpcao: client.dataOpcaoSimei?.toString(),
      dataExclusao: client.dataExclusaoSimei?.toString()
    },

    // Outros
    tipoCliente: client.tipoCliente,
    segmento: client.segmento,
    pontoReferencia: client.pontoReferencia,
    efr: client.efr,
    ultimaAtualizacao: client.ultimaAtualizacaoReceitaWs?.toString(),
  };
}


/**
 * Formata CNPJ no padrão XX.XXX.XXX/XXXX-XX
 */
export function formatCnpj(cnpj: string | undefined): string {
  if (!cnpj) return '';
  // Remove caracteres não numéricos
  const cleanCnpj = cnpj.replace(/\D/g, '');
  // Aplica a formatação
  return cleanCnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
}
